export default {
	colors: {
		list: [
			{
				value: 'red',
				background: '#ff0000',
				title: 'Labeled "red"'
			},
			/*{
				value: 'orange',
				background: '#ff6600',
				title: 'Labeled "orange"'
			},*/
			{
				value: 'yellow',
				background: '#ffcc00',
				title: 'Labeled "yellow"'
			},
			{
				value: 'green',
				background: '#66cc00',
				title: 'Labeled "green"'
			},
			/*{
				value: 'aqua',
				background: '#00ddee',
				title: 'Labeled "aqua"'
			},*/
			{
				value: 'blue',
				background: '#3300ff',
				title: 'Labeled "blue"'
			},
			{
				value: 'purple',
				background: '#9900ff',
				title: 'Labeled "purple"'
			},
			{
				value: 'nocolor',
				title: 'No color label'
			}
		]
	}
};
